// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav_container {
  width: 5.5rem;
  height: 80vh;
  background-color: #231B27;
  margin-left: 2.5rem;
  padding: 2.25rem 0;
  border-radius: 1.25rem;
  font-size: 85%;
}
.nav_container .nav_section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}
.nav_container .nav_section .logo_m {
  margin-bottom: 1rem;
}
.nav_container .nav_section .logo_home .home_link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #FFFFFF;
}
.nav_container .nav_section .logo_home .home_link .home_logo {
  font-size: 1.5rem;
}
.nav_container .nav_section .logo_home .home_link .home_text {
  margin-top: -0.5rem;
}
.nav_container .nav_section .logo_project {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.nav_container .nav_section .logo_project .logo {
  font-size: 2rem;
  color: #FFFFFF;
}
.nav_container .nav_section .logo_project a {
  text-decoration: none;
  color: #FFFFFF;
  margin-top: -0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/layout/navbar/_Navbar.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,YAAA;EACA,yBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAFJ;AAII;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAFR;AAIQ;EACI,mBAAA;AAFZ;AAMY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AAJhB;AAMgB;EACI,iBAAA;AAJpB;AAMgB;EACI,mBAAA;AAJpB;AAQQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AANZ;AAOY;EACI,eAAA;EACA,cAAA;AALhB;AAOY;EACI,qBAAA;EACA,cAAA;EACA,mBAAA;AALhB","sourcesContent":["\n\n.nav_container{\n    width: 5.5rem;\n    height: 80vh;\n    background-color: #231B27;\n    // margin-top: 2.188rem;\n    margin-left: 2.5rem;\n    padding:  2.25rem 0;\n    border-radius: 1.25rem;\n    font-size: 85%;\n\n    .nav_section{\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 1.5rem;\n\n        .logo_m{\n            margin-bottom: 1rem;\n        }\n\n        .logo_home{\n            .home_link{\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                text-decoration: none;\n                color: #FFFFFF;\n\n                .home_logo{\n                    font-size: 1.5rem;\n                }\n                .home_text{\n                    margin-top: -.5rem;\n                }\n            }\n        }\n        .logo_project{\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            .logo{\n                font-size: 2rem;\n                color: #FFFFFF;\n            }\n            a{\n                text-decoration: none;\n                color: #FFFFFF;\n                margin-top: -.5rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
